import React from "react";
import PageRoutes from "./Routes/PageRoutes";
import "./App.css";

function App() {
  return (
    <div className="App">
      <PageRoutes />
    </div>
  );
}

export default App;
